import { Directive, ElementRef, EventEmitter, Output } from '@angular/core';
import { PlaceResult } from 'app/services/geolocate.service';

/**
 * Inspired by https://medium.com/@Analyzeet/use-google-places-api-autocomplete-using-angular-for-resident-and-office-address-23cc33078e8
 */
@Directive({
    selector: '[googleAutocomplete]',
})
export class GoogleAutocompleteDirective
{
    @Output() onAutocompleteSelected: EventEmitter<PlaceResult> = new EventEmitter<PlaceResult>();

    constructor(private el: ElementRef) {
        const autocomplete = new google.maps.places.Autocomplete(this.el.nativeElement,
                {
                    componentRestrictions: {country: 'US'},
                    types: ['address'],  // 'establishment' / 'address' / 'geocode'
                });
        google.maps.event.addListener(autocomplete, 'place_changed', () => {
            const place = autocomplete.getPlace();
            this.onAutocompleteSelected.emit(place);
        });
    }
}
